import {cloneVDom, CreateWidgetFromFirebaseNode} from "../components/v3/lib/vue-dom-obj";
import {ConvrrtFirebase} from "../convrrt-firebase";
import {PageEngineCommands} from "./AddSectionCommand";


export class PageSwapCommand extends PageEngineCommands {
    constructor(pageEngineComponent) {
        super();
        this._pageEngineComponent = pageEngineComponent

        this._newVDom = []
        this._newNodeBlocks = []

        this._oldNodeBlocks = this.clonedVDom.map(x => CreateWidgetFromFirebaseNode(x.node))
        this._oldVDom = [...this.clonedVDom]
    }

    get hasChanges () {
        return true
    }

    waitForDataPulling (database) {
        return new Promise(resolve => {
            database.ref.once('value', (snapshot) => {
                // allow DeltaRef Changes to take place
                // then push all changes a single change to history
                setTimeout(() => {
                    resolve()
                }, 1200)
            })
        })

    }
    async pullChanges(deltaKey) {
        const database = new ConvrrtFirebase(deltaKey)
        const _newNodeBlocksCopy = []
        await database.ref.on('child_added', (snap, prevKey) => {
            _newNodeBlocksCopy.push(snap.val())
            this._newNodeBlocks.push(snap.val())
        })
        await this.waitForDataPulling(database)
        this._newVDom = cloneVDom(_newNodeBlocksCopy, deltaKey)
    }

    async execute() {
        this.firebaseRef.set(this._newNodeBlocks).then(() => {
            this.clonedVDom = [...this._newVDom]
        })
    }

    async unExecute() {
        this.firebaseRef.set(this._oldNodeBlocks).then(() => {
            this.clonedVDom = [...this._oldVDom]
        })
    }
}
